// In dev this is "/" — src/setupProxy.js forwards /api to staging so the browser sees a
// single origin, which is what makes the SameSite=Lax session cookie attach on localhost.
export const BASE_URL = process.env.REACT_APP_API_URL;

// Absolute backend origin. BASE_URL is relative in dev, so anything that must be a real
// public URL (the API logs link, third-party redirects) has to use this instead.
export const API_ORIGIN = BASE_URL?.startsWith("http")
  ? BASE_URL.replace(/\/$/, "")
  : "https://staging.backend-app.usedeex.com"; // dev proxy target

// The single source of truth for "which environment am I talking to". Use this rather than
// testing API_URL for "staging": API_URL is "/" in dev, which reads as production and made
// the env banner announce PROD while actually proxying to staging.
export const IS_STAGING = API_ORIGIN.includes("staging");

/** Backend log viewer, linked from the dashboard. Derived so it can't drift. */
export const API_LOGS_URL = `${API_ORIGIN}/logs/home`;
